import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { withDebounce, DEBOUCE_AOUTOCOMPLETE_MS } from '../../utils/debounce';

import {
  updateTyperById,
  deleteTyperById,
  createTyper as createTyperByApi,
  getTypers as getTypersByApi,
} from '../../utils/api';

const SET_ERROR_ACTION = 'typers/setError';

const UNIQ_NAMES_ERR = 'Names must be unique';

const updateWithDebounce = withDebounce(async (typerId, newTyper, dispatch) => {
  const success = await updateTyperById(typerId, newTyper);
  dispatch(createAction(SET_ERROR_ACTION)({ error: success ? '' : UNIQ_NAMES_ERR }));
}, DEBOUCE_AOUTOCOMPLETE_MS);

const findTyperById = (id, state) => state.typers.typers.find(
  (typer) => typer.id === id,
);

export const getTypers = createAsyncThunk(
  'typers/getTypers',
  () => getTypersByApi(),
);

export const createTyper = createAsyncThunk(
  'typers/createTyper',
  async ({ name, password, enabled }, { dispatch }) => {
    const success = await createTyperByApi(name, password, enabled);
    dispatch(createAction(SET_ERROR_ACTION)({ error: success ? '' : UNIQ_NAMES_ERR }));
    dispatch(getTypers());
  },
);

export const deleteTyper = createAsyncThunk(
  'typers/deleteTyper',
  async (id, { dispatch, getState, rejectWithValue }) => {
    const typerToDelete = findTyperById(id, getState());
    if (!typerToDelete) {
      return rejectWithValue({ error: `Typer with id: ${id} not found` });
    }

    await deleteTyperById(id);
    dispatch(getTypers());
    return Promise.resolve();
  },
);

export const updateTyper = createAsyncThunk(
  'typers/updateTyper',
  ({ id, field, newValue }, { dispatch, getState, rejectWithValue }) => {
    const typerToUpdate = findTyperById(id, getState());
    if (!typerToUpdate) {
      return rejectWithValue({ error: `Typer with id: ${id} not found` });
    }

    const newTyper = { ...typerToUpdate, [field]: newValue };
    updateWithDebounce(id, newTyper, dispatch);

    return newTyper;
  },
);
